__turbopack_context__.v({
  "arrowLeft": "style-module-scss-module__iGeyaq__arrowLeft",
  "arrowRight": "style-module-scss-module__iGeyaq__arrowRight",
  "cardWrapper": "style-module-scss-module__iGeyaq__cardWrapper",
  "carouselArrow": "style-module-scss-module__iGeyaq__carouselArrow",
  "carouselScroller": "style-module-scss-module__iGeyaq__carouselScroller",
  "carouselWrapper": "style-module-scss-module__iGeyaq__carouselWrapper",
  "component": "style-module-scss-module__iGeyaq__component",
  "ctaButton": "style-module-scss-module__iGeyaq__ctaButton",
  "ctaCard": "style-module-scss-module__iGeyaq__ctaCard",
  "ctaHeading": "style-module-scss-module__iGeyaq__ctaHeading",
  "ctaText": "style-module-scss-module__iGeyaq__ctaText",
  "heading": "style-module-scss-module__iGeyaq__heading",
});
